import FileSuccess from "assets/img/svg/fileSuccess";
import { useTranslation } from "react-i18next";

import NavigationBlockWithBadge from "./NavigationBlockWithBadge";

interface DeclarationsLinkProps {
    /** Number of late declarations */
    lateCount: number;
    /** Whether the navigation is collapsed */
    isCollapsed?: boolean;
}

/**
 * Custom component for declarations link with late count badge
 */
const DeclarationsLink = ({ lateCount, isCollapsed = false }: DeclarationsLinkProps) => {
    const { t } = useTranslation();

    return (
        <NavigationBlockWithBadge
            icon={<FileSuccess color="currentColor" />}
            label={t("NavigationBar.Declarations")}
            badgeCount={lateCount}
            badgeTooltip={t("NavigationBar.LateDeclarations", { count: lateCount })}
            isCollapsed={isCollapsed}
        />
    );
};

export default DeclarationsLink;
